import classNames from 'classnames'
import React, { Dispatch, SetStateAction } from 'react'
import { useRouter } from 'next/router'
import Link from '../Link'
import { headerV3Config } from './constants/header-v2-config'
import { TDesktopDropDownOverlay } from './types/types'
import ArrowDown from '@/assets/common/arrowDown.inline.svg'
import { useAnalyticsEvent } from '@/hooks/analytics/use-analytics-event'
import { TGtm4Event } from '@/root/utils/common/web/gtm-events/types'
import Text from '@/stories/components/Common/NewText'

type TProps = {
  dwebDropdown: TDesktopDropDownOverlay
  toggleDwebDropdown: Dispatch<SetStateAction<TDesktopDropDownOverlay>>
}

const isSelected = (
  pathname: string = '',
  type: (typeof headerV3Config)[number]['relative_path'],
) => {
  return pathname.includes(type)
}

const DesktopNavigationV2 = ({ dwebDropdown, toggleDwebDropdown }: TProps) => {
  const router = useRouter()
  const pushEvent = useAnalyticsEvent()
  const { pathname } = router
  return (
    <nav className="flex flex-row items-center">
      {headerV3Config.map((item1, index) => {
        const { title, relative_path, event_data, showHr } = item1

        if (relative_path !== '') {
          return (
            <React.Fragment key={`${title}-${index}`}>
              {showHr && (
                <hr className="bg-brand-grey-light ml-3 hidden h-4 w-px lg:block" />
              )}
              <Link
                className={classNames(
                  'rounded-lg p-2.5 text-sm leading-5 text-brand-grey-dark hover:bg-brand-tertiary-grey',
                  {
                    '!text-brand-blue-azureRadiance': isSelected(
                      pathname,
                      relative_path,
                    ),
                  },
                )}
                href={relative_path}
                title={title}
                onClick={() => {
                  const gtm4Payload: TGtm4Event = {
                    eventData: {
                      ...event_data,
                      eventLabel: title,
                      section: 'Header',
                    },
                  }
                  pushEvent({
                    gtm4Payload,
                  })
                  toggleDwebDropdown(null)
                }}
              >
                {title}
              </Link>
            </React.Fragment>
          )
        }

        return (
          <div
            key={`${title}-${index}`}
            className={classNames(
              'flex cursor-pointer flex-col items-center rounded-lg p-2.5 text-brand-grey-dark duration-300 hover:bg-brand-tertiary-grey',
              {
                '!text-brand-blue-azureRadiance': dwebDropdown === title,
              },
            )}
            onClick={() => {
              const gtm4Payload: TGtm4Event = {
                eventData: {
                  ...event_data,
                  eventLabel: title,
                  section: 'Header',
                },
              }
              pushEvent({
                gtm4Payload,
              })
              if (dwebDropdown === title) {
                toggleDwebDropdown(null)
              } else {
                toggleDwebDropdown(title as TDesktopDropDownOverlay)
              }
            }}
          >
            <Text
              appearance="body1"
              tag="div"
              addClassName="flex flex-row items-center gap-2"
            >
              {title}
              {(item1.list1 || item1.list2) && (
                <div
                  className={classNames(
                    'h-5 w-5 transition-transform duration-200',
                    {
                      'rotate-180': dwebDropdown === title,
                    },
                  )}
                >
                  <ArrowDown />
                </div>
              )}
            </Text>
          </div>
        )
      })}
    </nav>
  )
}

export default DesktopNavigationV2
